import Seo from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { ServiceCard } from "@/components/ServiceCard";
import { AppointmentCTA } from "@/components/AppointmentCTA";
import { SITE } from "@/config/site";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <>
      <Seo
        title={`Medical Services — ${SITE.name}`}
        siteName={SITE.name}
        description={`Explore medical services at ${SITE.name}, Kasdol — general medicine, family healthcare, women's and child health, diagnostics and more.`}
      />
      <PageHeader
        title="Our Services"
        description="The services listed are editable demo content and will be updated with the hospital's confirmed service list."
        crumbs={[{ label: "Services" }]}
      />
      <section className="py-16 sm:py-20" data-testid="services-list-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 lg:gap-8">
            {SERVICES.map((s) => <ServiceCard key={s.slug} service={s} />)}
          </div>
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
